export enum PersonStatusEnum {
    Active = 0,
    Terminated = 1,
    Suspended = 2
}
